// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__dpSA2","itemTitle":"ClientEmergencyInfo_itemTitle__1T4VB","itemText":"ClientEmergencyInfo_itemText__2rC-U"};